import React from 'react'
import { NavLink, useMatch } from 'react-router-dom'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import RoundedIcon from '~components/ui/RoundedIcon'

const QuickLink = ({ link, title, icon = 'dashboard', basket, exact, className }) => {
  const match = useMatch({ path: link, end: exact })
  const isActive = !!match

  return (
    <NavLink
      to={link}
      className={classNames('group flex items-center', className)}
      aria-label={title}
    >
      <span className="relative block">
        <RoundedIcon
          name={icon}
          className="block w-10 h-10 lg:w-7 lg:h-7"
          active={isActive}
        />

        {basket && (
          <span className="absolute top-0 right-0 block w-3 h-3 rounded-1/2 bg-charcoal lg:w-2 lg:h-2" aria-hidden="true">
            <span className="absolute top-0 bottom-0 left-0 right-0 inline-flex w-full h-full m-auto rounded-full opacity-75 animate-limited-ping bg-charcoal"></span>
          </span>
        )}
      </span>

      <span className="hidden ml-2 lg:block">
        {title}
      </span>
    </NavLink>
  )
}

QuickLink.propTypes = {
  link: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  icon: PropTypes.string,
  basket: PropTypes.bool,
  exact: PropTypes.bool,
  className: PropTypes.string
}

export default QuickLink
